/**
 * Theme props for Account Select component
 */

export const displayItemBalanceWidth = 152;
export const displayItemNumberWidth = 140;

export const listItemBalanceWidth = 172;
export const listItemNumberWidth = 180;
